
import TipoEnvioEstadoCuentaModel from "@/models/TipoEnvioEstadoCuenta/TipoEnvioEstadoCuentaModel";
import UmbracoApiService from "@/services/UmbracoApiService";
import WsdlService from "@/services/WsdlService";
import GlobalConfig from "@/GlobalConfig";
import { Component, Vue } from "vue-property-decorator";
import Option from "@/models/SelectOption";
import TypeResponse from "@/models/WsdlResponses/TypeResponse";
import { AxiosResponse } from "axios";
import FundTypeObj from "@/models/WsdlResponses/FundTypeObj";
import FundType from "@/models/WsdlResponses/FundType";
import Swal from "sweetalert2";
import TipoEnvioEstadoCuentaForm from "@/components/TipoEnvio_EstadoCuenta/TipoEnvioEstadoCuentaForm.vue";
import TipoEnvioEstadoCuentaResult from "@/components/TipoEnvio_EstadoCuenta/TipoEnvioEstadoCuentaResult.vue";

@Component({
    components: {
        TipoEnvioEstadoCuentaForm,
        TipoEnvioEstadoCuentaResult,
    },
})
export default class TipoEnvioEstadoCuenta extends Vue {
    public isLoading: boolean = false;
    public umbracoService = new UmbracoApiService();
    public wsdlService: WsdlService = new WsdlService();
    public userId: string = this.$store.state.user.cedula;
    public isProcessing: boolean = false;
    public umbracoBaseUrl: string = GlobalConfig.UMBRACO_BASE_URL;

    public labelData = new TipoEnvioEstadoCuentaModel();

    async mounted() {
        this.labelData = await this.umbracoService.getTipoEnvioEstadoCuenta();
    }
    public process(via: TypeResponse, tipoFondo: FundType, ip: string) {
		if(ip){
			this.isLoading = true;
			let requestBody = {
            tipoEnvio: via.tipRespuesta,
            ip: ip,
            codigoUsuario: this.userId,
            codCuenta: tipoFondo.codcuenta,
            tipoFondo: tipoFondo.valor,
			};
			this.wsdlService
				.postTipoEnvioEstadoCuenta(requestBody)
				.then(() => {
					this.isProcessing = true;
				})
				.catch(() => {
					Swal.fire({
						text: "Lo siento, ha ocurrido un error en la comunicación, por favor intenta más tarde.",
						icon: "error",
						showConfirmButton: true,
						confirmButtonText: "Ok",
						onClose: () => {},
					});
				}).finally(() => {this.isLoading = false;});
		}
		else{
			Swal.fire({
                title: "",
                text: "No se pudo obtener la dirección IP del consultante, por favor, recarga la página.",
                icon: "error",
            });
		}
    }
}
